import { apiRequest, getResource } from "../api/http";

// Comments moderation ("comments" section): pin, Alain Foka's heart,
// messages posted on behalf of Alain Foka, deletion.
const BASE = "/api/admin/comments";
const EMPTY_PAGE = { items: [], total: 0, page: 1, pageSize: 25 };

const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/**
 * Comments: `{ contentType, contentId }` for one video / episode (threads, pinned first),
 * otherwise the latest comments and replies of the site. `filter`: all | pinned | hearted
 * | official | thanks | premium; `q`: text. Resolves with `{ items, total, page, pageSize }`.
 */
export const getModerationComments = (params) => getResource(`${BASE}${query(params)}`, { fallback: EMPTY_PAGE });

export const setPinned = (id, pinned) => apiRequest(pinned ? "put" : "delete", `${BASE}/${id}/pin`, { rethrow: true });
export const setHearted = (id, hearted) => apiRequest(hearted ? "put" : "delete", `${BASE}/${id}/heart`, { rethrow: true });
export const deleteComment = (id) => apiRequest("delete", `${BASE}/${id}`, { rethrow: true });

/** Message (`{ contentType, contentId, comment, pin }`) or reply (`{ parentId, comment }`) as Alain Foka. */
export const postOfficial = (body) => apiRequest("post", `${BASE}/official`, { data: body, rethrow: true });

export const apiError = (error) => error?.response?.data?.message || "";
